import { useTranslation } from "react-i18next";
import { Button, Grid, MenuItem, Typography } from "@mui/material";
import { OrderTesVariation } from "../../orderTesVariation/OrderTesVariation";
import { VariationSelection } from "../../../../common/types/apiTypes";
import { useState } from "react";
import { useAppSelector } from "../../../../app/hooks";
import { TextFieldLight } from "../../../../common/components/styled/styled";

type Props = {
  reasonForTemporaryEmployment: string;
  tesId: string;
  date: Date;
  tesVariations: VariationSelection[];
  onTesVariationChange: (variation: VariationSelection[]) => void;
};

export const TermsOfEmployment = ({
  reasonForTemporaryEmployment,
  tesId,
  date,
  tesVariations,
  onTesVariationChange,
}: Props) => {
  const { t } = useTranslation("order");
  const [tesSettingsOpen, setTesSettingsOpen] = useState(false);
  const { tes: tesTranslations } = useAppSelector((state) => state.localized);

  return (
    <>
      <Grid
        container
        item
        xs={12}
        justifyContent="flex-end"
        direction="row"
        spacing={1}
        mb={2}
      >
        <Grid
          container
          item
          xs={3}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Typography variant="secondary">
            {t("order:reasonForTemporaryEmployment")}
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <TextFieldLight
            disabled
            select
            fullWidth
            sx={{
              width: "363px",
            }}
            size="small"
            name="reasonForTemporaryEmployment"
            value={reasonForTemporaryEmployment}
            onChange={() => {}}
          >
            <MenuItem value={reasonForTemporaryEmployment}>
              {t(reasonForTemporaryEmployment)}
            </MenuItem>
          </TextFieldLight>
        </Grid>
        <Grid
          container
          item
          xs={3}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Typography variant="secondary">{t("common:tes")}</Typography>
        </Grid>
        <Grid container item xs={9} alignItems="center">
          <Grid item container>
            <TextFieldLight
              disabled
              select
              fullWidth
              sx={{
                width: "363px",
              }}
              size="small"
              name="tes"
              value={tesId}
              onChange={() => {}}
            >
              <MenuItem value={tesId}>{tesTranslations[tesId]}</MenuItem>
            </TextFieldLight>
            <Button
              sx={{ textTransform: "none", marginLeft: "0.5rem" }}
              variant="text"
              disabled={!tesId}
              onClick={() => setTesSettingsOpen(true)}
            >
              {t("common:settingsDots")}
            </Button>
          </Grid>
        </Grid>
        <OrderTesVariation
          variationDefaults={tesVariations}
          tesId={tesId}
          date={date}
          open={tesSettingsOpen}
          onClose={() => setTesSettingsOpen(false)}
          setTesVariation={onTesVariationChange}
        />
      </Grid>
    </>
  );
};
